import { render, staticRenderFns } from "./MemberDetails.vue?vue&type=template&id=07379e14&scoped=true"
import script from "./MemberDetails.vue?vue&type=script&lang=js"
export * from "./MemberDetails.vue?vue&type=script&lang=js"
import style0 from "./MemberDetails.vue?vue&type=style&index=0&id=07379e14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07379e14",
  null
  
)

export default component.exports